import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .ant-modal-content {\n    display: flex;\n    min-height: 500px;\n    padding: 44px 40px 40px;\n    border-radius: 12px;\n  }\n  .ant-modal-body {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n  .ant-modal-close svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  @media (max-width: 1200px) {\n    .ant-modal-content {\n      min-height: auto;\n    }\n  }\n  @media (max-width: 768px) {\n    .ant-modal-content {\n      padding: 28px 20px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  margin: 28px 0 20px;\n  color: ",
        ";\n  text-align: center;\n  font-size: 24px;\n  line-height: 32px;\n\n  &,\n  strong {\n    font-weight: 700;\n  }\n  strong {\n    color: ",
        ";\n  }\n\n  @media (max-width: 768px) {\n    font-size: 20px;\n    line-height: 30px;\n    letter-spacing: -0.2px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n\n  button {\n    min-width: 120px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  padding-right: 4px;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  margin-left: -20px;\n  border: none;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1;\n  height: 24px;\n  gap: 12px;\n\n  & > div:nth-child(",
        ") {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  width: 8px;\n  height: 8px;\n\n  background-color: ",
        ";\n  border-radius: 16px;\n  line-height: 8px;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  display: inline-block;\n  padding: 3px 5.203px 3.906px 5.5px;\n  background-color: ",
        ";\n  border-radius: 16px;\n  color: ",
        ";\n  line-height: 9px;\n\n  svg {\n    width: 23.297px;\n    height: 9.094px;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n  &:not(:last-of-type) {\n    margin-bottom: 60px;\n  }\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n  & > dt {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    color: ",
        ";\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 26px;\n\n    .ant-btn {\n      margin-left: 2px;\n    }\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from "antd";
import { useCallback, useMemo } from "react";
import useClassStore from "src/store/class";
import styled from "styled-components";
import NoPadButton from "../common/Button/NoPadButton";
import _TextField from "../common/TextField";
import Icon from "../icon/Icon";
import { ArrowLeft1_5, PickBadgeText } from "../icon/IconList";
export const StyledModal = styled(Modal).withConfig({
    componentId: "sc-3471726c-0"
})(_templateObject());
export const ModalTitle = styled.h4.withConfig({
    componentId: "sc-3471726c-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_800, (props)=>props.theme.new.colors.sol_indigo_500);
export const NewClassActionsContainer = styled.div.withConfig({
    componentId: "sc-3471726c-2"
})(_templateObject2());
const NewClassStepperWrapper = styled.div.withConfig({
    componentId: "sc-3471726c-3"
})(_templateObject3(), (props)=>!props.backButton ? "\n    padding-left: 4px;\n\n    .back-button {\n        display: none;\n    }" : "");
const BackButton = styled(NoPadButton).withConfig({
    componentId: "sc-3471726c-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_800);
const NewClassStepperIndicatorWrapper = styled.div.withConfig({
    componentId: "sc-3471726c-5"
})(_templateObject5(), (props)=>props.activeStep, (props)=>props.theme.new.colors.sol_gray_800);
const NewClassStepperIndicator = styled.div.withConfig({
    componentId: "sc-3471726c-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_gray_200);
export const NewClassStepper = ()=>{
    const { step  } = useClassStore((state)=>state.adding);
    const { setAdding  } = useClassStore((param)=>{
        let { setAdding  } = param;
        return {
            setAdding
        };
    });
    const handleClick = useCallback(()=>{
        setAdding({
            step: step - 1
        });
    }, [
        setAdding,
        step
    ]);
    const array = useMemo(()=>new Array(2).fill(null), []);
    return /*#__PURE__*/ _jsxs(NewClassStepperWrapper, {
        backButton: step > 1,
        children: [
            /*#__PURE__*/ _jsx(BackButton, {
                className: "back-button",
                type: "link",
                onClick: handleClick,
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: ArrowLeft1_5
                })
            }),
            /*#__PURE__*/ _jsx(NewClassStepperIndicatorWrapper, {
                activeStep: step,
                children: array.map((_, idx)=>/*#__PURE__*/ _jsx(NewClassStepperIndicator, {}, idx))
            })
        ]
    });
};
export const TextField = (param)=>{
    let { name , value , ...props } = param;
    const { setAdding  } = useClassStore((param)=>{
        let { setAdding  } = param;
        return {
            setAdding
        };
    });
    const handleChange = useCallback((ev)=>{
        setAdding({
            [name]: ev.target.value
        });
    }, [
        name,
        setAdding
    ]);
    const handleClear = useCallback(()=>{
        setAdding({
            [name]: ""
        });
    }, [
        name,
        setAdding
    ]);
    return /*#__PURE__*/ _jsx(_TextField, {
        ...props,
        name: name,
        value: value,
        onChange: handleChange,
        onClear: handleClear
    });
};
const PickChipContainer = styled.div.withConfig({
    componentId: "sc-3471726c-7"
})(_templateObject7(), (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.white);
export const PickChip = ()=>{
    return /*#__PURE__*/ _jsx(PickChipContainer, {
        children: /*#__PURE__*/ _jsx(Icon, {
            icon: PickBadgeText
        })
    });
};
export const ClassSectionContainer = styled.dl.withConfig({
    componentId: "sc-3471726c-8"
})(_templateObject8(), (props)=>props.theme.new.colors.sol_gray_700);
